"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyGroupBuy = copyGroupBuy;
exports.deleteGroupBuy = deleteGroupBuy;
exports.directGroupBuyRefund = directGroupBuyRefund;
exports.exportGroupBuyOrder = exportGroupBuyOrder;
exports.exportGroupBuyRefund = exportGroupBuyRefund;
exports.fullGroupBuyRefund = fullGroupBuyRefund;
exports.getGroupBuyDetail = getGroupBuyDetail;
exports.getGroupBuyList = getGroupBuyList;
exports.getGroupBuyOrderList = getGroupBuyOrderList;
exports.getGroupBuyRefundList = getGroupBuyRefundList;
exports.saveGroupBuy = saveGroupBuy;
exports.toggleGroupBuyStatus = toggleGroupBuyStatus;
exports.uploadGroupBuyImage = uploadGroupBuyImage;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
/**
 * 获取拼团活动列表
 * @param {Object} query - 查询参数
 */
function getGroupBuyList(query) {
  return (0, _requestAuth.default)({
    url: '/groupBuy/list',
    method: 'get',
    params: query
  });
}

/**
 * 获取拼团活动详情
 * @param {Number} id - 活动ID
 */
function getGroupBuyDetail(id) {
  return (0, _requestAuth.default)({
    url: "/groupBuy/".concat(id),
    method: 'get'
  });
}

/**
 * 保存拼团活动（新增或更新）
 * @param {Object} data - 活动数据
 */
function saveGroupBuy(data) {
  return (0, _requestAuth.default)({
    url: '/groupBuy',
    method: 'post',
    data: data
  });
}

/**
 * 删除拼团活动
 * @param {Number} id - 活动ID
 */
function deleteGroupBuy(id) {
  return (0, _requestAuth.default)({
    url: "/groupBuy/".concat(id),
    method: 'delete'
  });
}

/**
 * 启用/禁用拼团活动
 * @param {Number} id - 活动ID
 * @param {Number} enabled - 状态值
 */
function toggleGroupBuyStatus(id, enabled) {
  return (0, _requestAuth.default)({
    url: "/groupBuy/toggleStatus/".concat(id),
    method: 'post',
    data: {
      enabled: enabled
    }
  });
}

/**
 * 上传拼团活动图片
 * @param {File} file - 图片文件
 */
function uploadGroupBuyImage(file) {
  var formData = new FormData();
  formData.append('file', file);
  return (0, _requestAuth.default)({
    url: '/groupBuy/uploadImage',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

/**
 * 复制拼团活动
 * @param {Number} id - 活动ID
 */
function copyGroupBuy(id) {
  return (0, _requestAuth.default)({
    url: "/groupBuy/copy/".concat(id),
    method: 'post'
  });
}

// ===================== 拼团订单（全部订单） =====================

/**
 * 获取拼团订单列表（全部订单）
 * @param {Object} query - 查询参数
 */
function getGroupBuyOrderList(query) {
  return (0, _requestAuth.default)({
    url: '/groupBuy/orderPage',
    method: 'get',
    params: query
  });
}

/**
 * 导出拼团订单（异步，返回JSON）
 * @param {Object} query - 查询参数
 */
function exportGroupBuyOrder(query) {
  return (0, _requestAuth.default)({
    url: '/groupBuy/orderExport',
    method: 'get',
    params: query
  });
}

// ===================== 拼团退款订单 =====================

/**
 * 获取拼团退款订单列表
 * @param {Object} query - 查询参数
 */
function getGroupBuyRefundList(query) {
  return (0, _requestAuth.default)({
    url: '/groupBuyRefund/page',
    method: 'get',
    params: query
  });
}

/**
 * 导出拼团退款订单（异步，返回JSON，结果到导出日志下载）
 * @param {Object} query - 查询参数
 */
function exportGroupBuyRefund(query) {
  return (0, _requestAuth.default)({
    url: '/groupBuyRefund/export',
    method: 'get',
    params: query
  });
}

/**
 * 管理员部分退款（仅退款，不作废券）
 * @param {Object} data - { orderId, money }
 */
function directGroupBuyRefund(data) {
  return (0, _requestAuth.default)({
    url: '/groupBuyRefund/directRefund',
    method: 'post',
    data: data
  });
}

/**
 * 管理员全额退款（退券+退款，需要验证券未使用）
 * @param {Object} data - { orderId }
 */
function fullGroupBuyRefund(data) {
  return (0, _requestAuth.default)({
    url: '/groupBuyRefund/fullRefund',
    method: 'post',
    data: data
  });
}